export const POLLING_INTERVAL = 60 * 1000;
export const ENTER_KEYCODE = 13;
